import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=12898a06&scoped=true"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Billing.vue?vue&type=style&index=0&id=12898a06&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "12898a06",
  "cd4121d6"
  
)

export default component.exports